import React, { useEffect, useState, useRef } from 'react';
import './solutions/Solutions.css'; // you can style it here
import '../App.css';
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "",
    poster: "/videos/careersBackground.png",
    heading: "Join our team​",
    subheading: "Check out our current openings and send in your resume. We’d love to learn more about you.",
    buttonLink: "https://www.paycomonline.net/v4/ats/web.php/jobs?clientkey=E16932AE49B633ABC9CF0AEE797D7AEF"
  }
];

const images = [
  '/images/careers/1.jpg',
  '/images/careers/2.jpg',
  '/images/careers/3.jpg',
  //'/images/careers/4.jpg', blurry
  '/images/careers/5.jpg',
  '/images/careers/6.jpg',
  // Add more image paths here
];

const qaData = [
  {
    question: "What kinds of skills really shine in your group?",
    answer:
      "They have an ability to listen to our customers and understand the challenges they are facing and collaborate with other Go!Foton subject matter experts to leverage innovation and solve challenges in exciting ways.​"
  },
  {
    question: "Do you have a team mantra or sub-culture?",
    answer:
      "We have three simple rules. First, act with integrity. Be respectful and treat people the way you want to be treated. Second, have good morals and ethics. Do what’s right and follow the rules. Push for change in the right way. Third, be honest. Always tell the truth and do what you say.​"
  },
  {
    question: "What are your expectations of the team?",
    answer:
      "Wrap your customer in love, bring a positive attitude to work, and raise your hand and ask for help early in any process.​"
  },
  {
    question: "Can you share a story that shows these principles in action?",
    answer:
      "A client had strict specifications for wavelength management to support NG-PON2 in a central office. They had already deployed a fiber management platform and there was an IP barrier. Our solution was vertically integrating WDM capabilities with the SELFOC technology. We avoided IP conflict with an innovative design that was easier for the client to work with and saved the client nearly nine million dollars in their project.​"
  }
];

const qaData2 = [
  {
    question: "What is the company culture?",
    answer:
      "Our employees highlight a variety of characteristics about our culture. They say Go!Foton is customer focused (on both internal and external customers), performance driven, trusting, and that decision making is data-based.​"
  },
  {
    question: "Do you offer training and development?",
    answer:
      "Yes, we provide our employees with both video and in-person training.​"
  },
  {
    question: "What is the company work-life balance like?",
    answer:
      "Important to the company culture, we have a generous PTO policy, floating holidays (4) and company observed holidays (9) and offer flexible work-from-home when/as needed.​"
  },
  {
    question: "How is performance monitored and managed?",
    answer:
      "Annual performance is measured based on competencies aligned with the company's six cornerstones and cascading goals.​"
  },
  {
    question: "What benefits do you offer?",
    answer:
      "Go!Foton has a very attractive benefit package. Employees can opt into medical and dental coverage with the premium costs covered by the company ranging from 99% for employee-only coverage, to 87% for additional dependent coverage. We also offer reimbursement payments for anyone who opts out of medical coverage. The company provides FREE Vision, Life, AD&D, and Long-Term Disability coverage for all employees. Additionally, we offer a 401(k) program with a 50% company match of the first 6% of employee contributions. And our PTO policy includes 4 floating holidays, 9 company observed holidays, and a carry-over feature.​"
  },
];



function Careers() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [showMore1, setShowMore1] = useState(false);
  const [showMore2, setShowMore2] = useState(false);
  const [showMore3, setShowMore3] = useState(false);


const productFamilies = [
  'Fiber Cable Assemblies',
  'Fiber Panels',
  'Frames',
];

const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

const facts = [
    { label: "Years of in-house manufacturing", value: 25, prefix: "", suffix: "+", key: "years" },
    { label: "Continents with operations", value: 3, prefix: "", suffix: "", key: "continents" },
    { label: "employees dedicated to your needs", value: 2000, prefix: "~", suffix: "", key: "employees" },
    { label: "on-time delivery", value: 95, prefix: ">", suffix: "%", key: "delivery" },
  ];

  const [counts, setCounts] = useState({
    years: 0,
    continents: 0,
    employees: 0,
    delivery: 0,
  });

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = index => {
    setActiveIndex(prev => (prev === index ? null : index));
  };


  useEffect(() => {
    const animationFrames = {};
    const durations = 600; // in ms

    facts.forEach(fact => {
      const start = performance.now();

      const animate = now => {
        const progress = Math.min((now - start) / durations, 1);
        const currentValue = Math.floor(progress * fact.value);

        setCounts(prev => ({
          ...prev,
          [fact.key]: currentValue,
        }));

        if (progress < 1) {
          animationFrames[fact.key] = requestAnimationFrame(animate);
        }
      };

      animationFrames[fact.key] = requestAnimationFrame(animate);
    });

    return () => {
      Object.values(animationFrames).forEach(cancelAnimationFrame);
    };
  }, []);

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);




useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
          controls disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p style={{ marginBottom: 35}}>{slides[0].subheading}</p>
            <a
              href={slides[0].buttonLink}
              className="cta-button"
              style={{ textDecoration: 'none' }}
              target='_blank'
            >
              View jobs
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-centeredText" style={{ marginTop: -20}}>
        <div className="solutions-section-centeredText-text-container">

          <h2 className="solutions-section-centeredText-subheading">What drives us is you</h2>
          <p className="solution-section-centeredText-description">Meet and join our team of problem-solvers. We love investigating problems, are inspired by nature, and driven to deliver solutions that add value and betterment to your network and lives.​​</p>
        
              <div className="image-carousel">
      {images.map((src, idx) => (
        <img
          key={idx}
          src={src}
          className={`carousel-image ${idx === current ? 'active' : ''}`}
          alt={`Slide ${idx + 1}`}
        />
      ))}
    </div>        
        
        </div>
      </div>

  <div className="solutions-section-centeredText">
      <div className="solutions-section-centeredText-text-container">
        <h2 className="solutions-section-centeredText-subheading" style={{textAlign: 'center'}}>Frequently Asked Questions</h2>
      </div>

      <div className="qa-accordion">
      {qaData2.map((item, index) => (
        <div key={index} className="accordion-item">
          <div
            className="accordion-question"
            onClick={() => toggleIndex(index)}
          >
            <span style={{fontSize: 20}}>{item.question}</span>
            <span className="icon">{activeIndex === index ? '−' : '+'}</span>
          </div>
          {activeIndex === index && (
            <div className="accordion-answer">
              <p style={{fontSize: 20, textAlign: 'left'}}>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
    </div>

      <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Get to know us</h2>
          <p className="solution-section-centeredText-description">We have a diverse and flexible team loaded with talent​​</p>
 <div className="team-container">
      {/* Profile 1 */}
      <div className="team-card">
        <img src="/images/cassandra.jpg" alt="Cassandra" className="team-image" />
        <p style={{fontSize: 20, color: '#4D4D4F'}}>Meet Cassandra Kragh, HR Manager based in New Jersey.<br/><br/></p>
        <p style={{fontSize: 20, color: '#4D4D4F'}}>
          Cassandra joined in Spring 2025 and is excited to be a part of Go!Foton because “there’s so much rapid change in technology and we’re a part of the innovation contributing to that change. We are making an impact by streamlining the connectivity needed for the industrial world and I’m excited to be a part of that.”<br/><br/>
        </p>
        {!showMore1 ? (
          <>
            <p style={{fontSize: 20, color: '#4D4D4F'}}> 
              We appreciate Cassandra’s creativity and imagination. She’s currently reading “Rising Dawn”...
            </p>
            <button className="read-more-careers" onClick={() => setShowMore1(true)}>Read more</button>
          </>
        ) : (
          <>
            <p style={{fontSize: 20, color: '#4D4D4F'}}>
              We appreciate Cassandra’s creativity and imagination. She’s currently reading “Rising Dawn” which is the fourth book in the "Guardians of the Maiden" series. Her ideal day would be listening to a new audiobook while eating take-out and coloring an epic scene of dragons or other mythical creatures. She says she’s very obsessed with romantic fantasy books and spends most evenings listening to an audiobook while coloring some epic images.
            </p>
            <button className="read-more-careers" onClick={() => setShowMore1(false)}>Read less</button>
          </>
        )}
      </div>

      {/* Profile 2 */}
      <div className="team-card">
        <img src="/images/ari.jpg" alt="Ari" className="team-image" />
        <p style={{fontSize: 20, color: '#4D4D4F'}}>Meet Ari Sella – Sales Manager, Data Center, and AI.<br /><br /></p>
        <p style={{fontSize: 20, color: '#4D4D4F'}}>
          Ari sees the potential for Go!Foton to help customers in multiple scenarios. “The offering is relevant in every DC deployment regardless of project details – operator side, tenant side, new construction, facility upgrades, and more.”
        </p>
        {!showMore2 ? (
          <>
            <p style={{fontSize: 20, color: '#4D4D4F'}}>
              <br/>Ari enjoys working with so many different people and being part of transformative projects...
            </p>
            <button className="read-more-careers" onClick={() => setShowMore2(true)}>Read more</button>
          </>
        ) : (
          <>
            <p style={{fontSize: 20, color: '#4D4D4F'}}>
              <br />Ari enjoys working with so many different people and being part of transformative projects. Ari has contagious enthusiasm about the industry. He offers the following insights for people interested in this industry:
              1. There’s so much opportunity because of how quickly it continues to grow.
              2. Learn about power, self gen, and renewable off-grid energy. This will be the future for Super Compute environments.
            </p>
            <p style={{fontSize: 20, color: '#4D4D4F'}}>
              <br/>Outside of work, Ari volunteers with the North Miami Beach Little League and enjoys traveling with his family. As a lifelong New York Mets fan, it’s only fitting that his favorite book is If at First – a season with the 1985 Mets by Keith Hernandez.
            </p>
            <button className="read-more-careers" onClick={() => setShowMore2(false)}>Read less</button>
          </>
        )}
      </div>

            {/* Profile 3 */}
      <div className="team-card">
        <img src="/images/careers/greg.png" alt="Greg" className="team-image" />
        <p style={{fontSize: 20, color: '#4D4D4F'}}>Say hello to Greg Ash, Sr. Application Engineer with Go!Foton since November, 2024<br /><br /></p>
        <p style={{fontSize: 20, color: '#4D4D4F'}}>
          Greg joined us having worked alongside Patrick Anderson, David Chen, and Michael Zammit in the past. He says he was excited by the challenge of bringing the outside plant product line to market for a company and working alongside the “brilliant minds I get to learn from every day.”
        </p>
        {!showMore3 ? (
          <>
            <p style={{fontSize: 20, color: '#4D4D4F'}}>
              <br/>According to Greg, the absolute best part of being an Application Engineer is being...
            </p>
            <button className="read-more-careers" onClick={() => setShowMore3(true)}>Read more</button>
          </>
        ) : (
          <>
            <p style={{fontSize: 20, color: '#4D4D4F'}}>
              <br />According to Greg, the absolute best part of being an Application Engineer is being constantly challenged to solve complex problems and concerns for customers. He also loves working with an amazing team of sales professionals that truly rely on relationships to support their customers (and going to all the nice dinners with the customers since Sales pays)!<br/><br/>
Sounds good, right? He offers the following advice for new entrants to the industry. “Don’t ever try to be the smartest person in the room. There are plenty of those folks around. Find a group of people who want to teach and pass along their experiences in the industry. Listen to all perspectives and know that there is not a one-size-fits-all solution ever. Learn ALL you can about the industry that you are in. You don’t have to master all of it but understand the WHY to solve issues for your customer.”<br/><br/>
When not solving technical challenges, Greg loves Mel Brooks movies, his 3 dogs (a 7-year-old Boxer named Laney and 4-year-old brother and sister Black Labs named Bob and Bonnie), the Dallas Cowboys, and a well-built turkey club with crunchy lettuce and bacon. But his family tops his love list. Greg says they’re the “greatest family in the world. My wife of 30 years, Jennifer, is a Special Education teacher.” Their daughter Megan is in marketing and their two boys, Gregory and Thomas, are both active-duty military for USMC and Air Force, respectively. He adds, “the greatest addition to the family is my daughter-in-law, Andrea, and the best-looking grandson ever, Matthew.” Greg, we can’t argue. He’s adorable!<br/><br/>
What’s next for Greg? He hopes to see the penguins in Patagonia, someday. Until then, you might find him at a local taco joint or taking a relaxing hike by a river or exploring new places with his wife.
            </p>
            <p style={{fontSize: 20, color: '#4D4D4F'}}>
              <br/>Outside of work, Ari volunteers with the North Miami Beach Little League and enjoys traveling with his family. As a lifelong New York Mets fan, it’s only fitting that his favorite book is If at First – a season with the 1985 Mets by Keith Hernandez.
            </p>
            <button className="read-more-careers" onClick={() => setShowMore3(false)}>Read less</button>
          </>
        )}
      </div>
    </div>



        </div>
      </div>

      <div className="solutions-section-centeredText" style={{ marginTop: 30}}>
        <div className="solutions-section-centeredText-text-container"> 
          <div style={{display: 'flex', flexDirection: 'row'}}>
          <img src="/images/leadership/mark-spotlight.jpg" alt="Ari" className="team-image" style={{ height: 500, marginRight: 75}} />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'left'}}>
            <h2 className="solutions-section-centeredText-subheading">Spotlight:<br/>SVP of Sales, Mark Miller</h2>
            <p className="solution-section-centeredText-description">If you’d like to know more about how our culture and responsibilities come together, read on.  Our VP of Sales for global data center solutions, telecom, and MSO connectivity solutions lays it out. ​​</p>
          </div>
        </div>
<div className="qa-accordion">
      {qaData.map((item, index) => (
        <div key={index} className="accordion-item">
          <div
            className="accordion-question"
            onClick={() => toggleIndex(index)}
          >
            <span style={{fontSize: 20}}>{item.question}</span>
            <span className="icon">{activeIndex === index ? '−' : '+'}</span>
          </div>
          {activeIndex === index && (
            <div className="accordion-answer">
              <p style={{fontSize: 20, textAlign: 'left'}}>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
       
        </div>
      </div>


        <div className="curved-footer-solutions">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

    
  );
}

export default Careers;
